import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApplicationStateService } from './application-state.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private http = inject(HttpClient);
  private applicationStateService = inject(ApplicationStateService);


  checkForScheduledMaintenanceLockout() {
    let reqOptions = {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin' : "*",
      },
    };

    return this.http.get(`${environment.EC2URL}maintenance`, reqOptions).pipe(
      map((res: any) => {
        if (res.canLogin) {
          const scheduledTime = res.scheduledTime;
          this.applicationStateService.setScheduledMaintenanceTime(scheduledTime);
        }

        return res.canLogin;
      })
    )
  }

  checkForScheduledMaintenanceChanges(): Promise<void> {
    let reqOptions = {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin' : "*",
      },
    };
  
    return this.http.get(`${environment.EC2URL}maintenance`, reqOptions).toPromise().then((res: any) => {
      this.applicationStateService.setScheduledMaintenanceTime(res.scheduledTime);
    });
  }
}